import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import { H3, Span, Text } from '@/components/atoms'
import { FileUpload, SelectedFileList } from '@/components/molecules'
import { useClaimsRentersStepTwo } from './page.claims.renters-step-two.hook'

interface ClaimsRentersStepTwoPageProps {
  hasSubmitError?: boolean
  isOffline?: boolean
}

export function ClaimsRentersStepTwoPage({
  hasSubmitError,
  isOffline,
}: ClaimsRentersStepTwoPageProps) {
  const { t } = useTranslation()
  const { control, rules, fieldErrors, addFiles, removeFile } =
    useClaimsRentersStepTwo()

  return (
    <div className="flex flex-col gap-6">
      <H3 className="text-[1.5rem] text-neutral-900">
        {t('claims.renters.stepTwo.title')}
      </H3>

      <Controller
        control={control}
        name="documents"
        rules={rules.documents}
        render={({ field }) => (
          <div className="flex flex-col gap-3">
            <FileUpload
              label={t('claims.renters.form.documentsLabel')}
              variant="document"
              multiple
              onFilesSelect={(files) => addFiles('documents', files)}
            />
            <SelectedFileList
              files={field.value}
              onRemove={(index) => removeFile('documents', index)}
            />
          </div>
        )}
      />

      <Controller
        control={control}
        name="photos"
        render={({ field }) => (
          <div className="flex flex-col gap-3">
            <FileUpload
              label={t('claims.renters.form.photosLabel')}
              multiple
              onFilesSelect={(files) => addFiles('photos', files)}
            />
            <SelectedFileList
              files={field.value}
              onRemove={(index) => removeFile('photos', index)}
            />
          </div>
        )}
      />

      {fieldErrors.attachments && (
        <Span className="text-error-base">{fieldErrors.attachments}</Span>
      )}

      {hasSubmitError && (
        <div role="alert" className="alert alert-error">
          <span>{t('claims.renters.form.submitError')}</span>
        </div>
      )}

      {isOffline && (
        <Text className="text-indigo-base !text-sm">
          {t('payment.offlineError')}
        </Text>
      )}
    </div>
  )
}
